import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AmenitiesListComponent } from './amenities-list/amenities-list.component';
import { AmenitiesCreateComponent } from './amenities-create/amenities-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: AmenitiesListComponent,
        data: {
          title: "Amenities List",
          breadcrumb: "Amenities List"
        }
      },
      {
        path: 'create',
        component: AmenitiesCreateComponent,
        data: {
          title: "Create Amenities",
          breadcrumb: "Create Amenities"
        }
      },
      {
        path: 'edit/:id',
        component: AmenitiesCreateComponent,
        data: {
          title: "Edit Amenities",
          breadcrumb: "Edit Amenities"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class AmenitiesRoutingModule { }
